import React from 'react';

import locationIcon from '@assets/img/icons/location.svg';
import MUILink from '@material-ui/core/Link';
import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

export interface BreadcrumbProps {
  items: { to?: string; text: string }[];
  separator?: string;
  iconHidden?: boolean;
  icon?: string;
  bottomLineHidden?: boolean;
}

const useStyles = makeMuiStyles((theme, common) => ({
  link: {
    ...common.middleText,
    color: theme.palette.primary.dark,
    textDecoration: 'underline',
    textUnderlineOffset: '7px',
  },
  nolink: {
    ...common.middleText,
    color: theme.palette.primary.dark,
  },
  inline: {
    display: 'inline-block',
    verticalAlign: 'middle',
  },
  locationIcon: {
    verticalAlign: 'middle',
    position: 'relative',
    top: 2,
  },
  space: {
    display: 'inline-block',
    width: 15,
  },
  separator: {
    display: 'inline-block',
    width: 44,
    color: theme.palette.primary.dark,
    textAlign: 'center',
  },
  bottomLine: {
    height: 1,
    backgroundColor: theme.palette.grey[200],
    marginTop: 8,
    marginBottom: 8,
  },
}));

export const Breadcrumb: React.FC<BreadcrumbProps> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const {
    items,
    separator = '/',
    iconHidden = false,
    icon = locationIcon,
    bottomLineHidden = false,
  } = props;

  const renderSep = (key: any, index: number) => {
    if (index > 0) {
      return (
        <span key={`sep_${key}`} className={classes.separator}>
          {separator}
        </span>
      );
    }
    return <></>;
  };

  return (
    <>
      <div className={classes.inline}>
        {!iconHidden && (
          <>
            <span className={classes.locationIcon}>
              <img src={icon} alt="location" width={19} />
            </span>
            <span className={classes.space} />
          </>
        )}

        {items.map((item, index) => {
          if (item.to == null) {
            return (
              <span key={`${item.text}${String(index)}`}>
                {renderSep(item.text, index)}
                <span
                  key={item.text}
                  className={clsx(
                    classes.nolink,
                    index === items.length - 1 && classes.fontWeight600Important,
                  )}
                >
                  {item.text}
                </span>
              </span>
            );
          }

          return (
            <span key={`${item.text}${String(index)}`}>
              {renderSep(item.text, index)}
              <MUILink
                classes={{ root: classes.link }}
                key={item.text}
                to={item.to}
                component={Link}
              >
                {item.text}
              </MUILink>
            </span>
          );
        })}
      </div>
      {!bottomLineHidden && <div className={classes.bottomLine} />}
    </>
  );
};
